export default {
  phones: [
    '+86 15928758550 （China）',
    '+86 18349353270（China）',
    '+1 4258668398 （USA）',
    '+880 1825459736 （Bangladesh）'
  ],
  menu: [{
    name: 'home',
    component: 'home'
  },
  {
    name: 'service',
    component: 'service',
    subMenu: [{
      title: 'ConsultationService',
      childrens: [{
        name: 'Enterprise Strategy & Transformation',
        component: 'enterprise'
      },
      {
        name: 'Business Process',
        component: 'businessProcess'
      },
      {
        name: 'Digital Revolution',
        component: 'digital'
      },
      {
        name: 'Enterprise Application',
        component: 'enterpriseApplication'
      },
      {
        name: 'CRM',
        component: 'crm'
      }
      ],
    },
    {
      title: 'Business services',
      childrens: [{
        name: 'Blockchains',
        component: 'blockchains'
      },
      {
        name: 'Business Application Procedure',
        component: 'businessApplication'
      },
      {
        name: 'Data Analytics',
        component: 'dataAnalytics'
      },
      {
        name: 'Artificial Intelligence',
        component: 'artificialIntelligence'
      },
      {
        name: 'AI Video Production',
        component: 'aiVideoProduction'
      }
      ]
    },
    {
      title: 'Technology Services',
      childrens: [{
        name: 'Software Development & Maintenance',
        component: 'softwareDevelopment'
      },
      {
        name: 'Enterprise Mobility',
        component: 'enterpriseMobility'
      },
      {
        name: 'Intelligent Manufacturing',
        component: 'intelligentManufacturing'
      },
      {
        name: 'Network Security',
        component: 'networkSecurity'
      },
      {
        name: 'Globalization&Localization',
        component: 'globalization'
      },
      {
        name: 'Big Data',
        component: 'bigData'
      },
      {
        name: 'Internet of Things',
        component: 'internetThings'
      },
      {
        name: 'Cloud',
        component: 'cloud'
      }
      ]
    },
    {
      title: 'Outsourcing',
      childrens: [{
        name: 'Application Outsourcing',
        component: 'applicationOutsourcing'
      },
      {
        name: 'Business Process Outsourcing',
        component: 'businessProcessOutsourcing'
      },
      {
        name: 'Customer Service',
        component: 'customerService'
      },
      {
        name: 'Human Resource',
        component: 'humanResource'
      },
      {
        name: 'Gaming field',
        component: 'gamingField'
      }
      ]
    }
    ]
  },
  {
    name: 'industry',
    component: 'industry'
  },
  {
    name: 'about us',
    component: 'aboutUs'
  },
  {
    name: 'jobs',
    component: 'jobs'
  },
  {
    name: 'contact us',
    component: 'contactUs'
  }
  ],
  languageList: [{
    name: 'Chinese',
    code: 1,
    tag: 'zh'
  },
  {
    name: 'English',
    code: 2,
    tag: 'en'
  },
  {
    name: 'Japanese',
    code: 8,
    tag: 'ja'
  }
  ],
  banners: [
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
    // {
    //   imgUrl: require('../../assets/images/home/home-banner.jpg'),
    //   title: 'Global IT Services Company',
    //   description: 'With branches in both China and the USA, MaesInfo is well positioned to serve clients globally, around the clock, catering to their needs on an individual basis.',
    //   component: ''
    // },
    // {
    //   imgUrl: require('../../assets/images/home/home-banner3.jpg'),
    //   title: '​​​​Large quantities of mid-senior talent reserve',
    //   description: '​​High quality and low cost action modes are carried out on time and on budget ',
    //   component: ''
    // },
    {
      imgUrl: require('../../assets/images/home/home-banner4.jpg'),
      title: 'Enterprise Digital Transformation Services',
      description: '',
      component: ''
    }
  ],
  // 服务列表
  serviceTitle: 'MAESINFO SERVICES',
  services: [
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称', size: 'big(比例最大), normal(比例第二大小), small(最小比例)'
    {
      imgUrl: require('../../assets/images/home/home-pic-14.jpg'),
      title: 'Industrial Automation',
      description: 'Reconstruct the core logic of production and bid farewell to the cumbersome repetitive processes.',
      component: 'intelligentManufacturing',
      size: 'small'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-1.jpg'),
      title: 'Software Development & Maintenance',
      description: 'With the continuous deepening of enterprise informatization, information systems have become massive and complex.',
      component: 'softwareDevelopment',
      size: 'small'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-2.jpg'),
      title: 'Artificial Intelligence',
      description: 'Artificial intelligence is leading the innovation of global companies.',
      component: 'artificialIntelligence',
      size: 'small'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-3.jpg'),
      title: 'Internet of Everythings',
      description: 'The Internet of Things is regarded as the new wave of the IT revolution after the Internet itself.',
      component: 'internetThings',
      size: 'small'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-4.jpg'),
      title: 'Blockchains',
      description: 'Blockchain is a new computer technology, used for diverse applications such as distributed data storage, ',
      component: 'blockchains',
      size: 'small'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-5.jpg'),
      title: 'Human Resource',
      description: 'Human Resources outsourcing service is a new talent management and service mode ',
      component: 'humanResource',
      size: 'small'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-6.jpg'),
      title: 'Big Data',
      description: 'Today, data is rooted in every corner of our lives more than ever before.',
      component: 'bigData',
      size: 'small'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-7.jpg'),
      title: 'Digital Revolution',
      description: 'The world has changed in a profound way as a result of technological development, and being up to date with the latest technologies .',
      component: 'digital',
      size: 'small'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-8.jpg'),
      title: 'Enterprise Strategy & Transformation',
      description: ' Business Transformation is a management strategy that implies a strategic change',
      component: 'enterprise',
      size: 'normal'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-9.jpg'),
      title: 'Application Outsourcing',
      description: `MaesInfo's software development services include application development and customized product development. `,
      component: 'applicationOutsourcing',
      size: 'big'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-10.jpg'),
      title: 'Data Analytics',
      description: 'Maesinfo uses advanced big data analysis technology to accelerate profit growth and succeed in the digital economy era.',
      component: 'dataAnalytics',
      size: 'big'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-11.jpg'),
      title: 'Enterprise Mobility',
      description: 'High-efficiency office environment, cost saving and integrated resource.',
      component: 'enterpriseMobility',
      size: 'normal'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-12.jpg'),
      title: 'Network Security',
      description: 'In the Internet age, network security is critical to business operations. ',
      component: 'networkSecurity',
      size: 'normal'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-13.jpg'),
      title: 'Globalization& Localization',
      description: 'Maesinfo. is an innovative service company specializing in providing intelligent IT solutions for world-renowned enterprises ',
      component: 'globalization',
      size: 'normal'
    }
  ],
  //  行业信息
  industryTitle: 'INDUSTRY',
  industry: [
    // icon: '图标地址', title: '标题'， component: '点击跳转组件名称'
    {
      icon: require('../../assets/images/home/home-icon-1.png'),
      title: 'high tech',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-2.png'),
      title: 'insurance',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-3.png'),
      title: 'Insurance',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-4.png'),
      title: 'finance',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-5.png'),
      title: 'capital makets',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-6.png'),
      title: 'software',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-7.png'),
      title: 'energy',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-8.png'),
      title: 'internet',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-9.png'),
      title: 'automotive',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-10.png'),
      title: 'health',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-11.png'),
      title: 'travel',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-12.png'),
      title: 'education',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-13.png'),
      title: 'entertainment',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-14.png'),
      title: 'retail',
      component: 'industry'
    }
  ],
  footer: {
    p1: `+86(028) 6593-5363 (China)`,
    p2: `+86 400-871-8663 (China)`,
    p3: `+86 15928758550 (China)`,
    p4: `+86 18349353270(China)`,
    p5: `+1 4258668398 (America)`,
    p6: `+880 1825459736 (Bangladesh)`,
    tell: `Contact us through Me`,
    phone: ' +86 183-4935-3270 / 400-871-8663',
    copyRight: 'Maes Consulting Inc.(TM) Copyright© 2005-2023 MaesInfo Corporation. All rights reserved'
  }
}
